import { render, staticRenderFns } from "./RemittanceForm.vue?vue&type=template&id=580c3e7e&scoped=true&"
import script from "./RemittanceForm.vue?vue&type=script&lang=js&"
export * from "./RemittanceForm.vue?vue&type=script&lang=js&"
import style0 from "./RemittanceForm.vue?vue&type=style&index=0&id=580c3e7e&prod&lang=scss&"
import style1 from "./RemittanceForm.vue?vue&type=style&index=1&id=580c3e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c3e7e",
  null
  
)

export default component.exports